module.exports = __webpack_public_path__ + "img/user-guide-flow-diagram.zh_cn.37a0a37e.png";